import { ReactComponentManifest } from "web/entrypoints/common/setup";
import { LystNewsArticle } from "web/react/pages/lyst-news/lyst-news-article";

export const lystNewsArticleComponents: ReactComponentManifest = {
    LystNewsArticle,
};
